import { graphql, useStaticQuery } from "gatsby"
import * as React from "react"

export default function Head({ data, customTitle, children }) {
  const { site } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            siteUrl
            title
            description
            author
          }
        }
      }
    `
  )

  const fallbackTitle = site.siteMetadata?.title
  const fallbackDescription = site.siteMetadata?.description
  const siteUrl = site.siteMetadata.siteUrl

  return (
    <>
      <meta charSet="utf-8" />
      <title>{customTitle ?? data?.title ?? fallbackTitle}</title>
      <meta
        name="description"
        content={data?.metaDesc ?? fallbackDescription}
      />

      {data?.opengraphTitle && (
        <>
          <meta property="og:title" content={data.opengraphTitle} />
          <meta property="og:description" content={data.opengraphDescription} />
          <meta property="og:type" content="website" />
          {/* {data.opengraphImage && (
            <meta
              property="og:image"
              content={siteUrl + data.opengraphImage?.localFile.url}
            />
          )} */}
        </>
      )}

      {data?.schema?.raw && (
        <script type="application/ld+json">{data.schema.raw}</script>
      )}

      {children}
    </>
  )
}
